'use client';

import { createTheme } from '@mantine/core';

export const theme = createTheme({
  // Nunito, for headings and body alike, as on collana.com. The variable is defined on <html> by
  // next/font in the root layout; setting it here is what applies it to Mantine's components too,
  // not just to plain elements.
  fontFamily: 'var(--font-nunito), sans-serif',
  headings: {
    fontFamily: 'var(--font-nunito), sans-serif',
  },

  // Override Mantine's default blue with the Collana brand green/teal (rgb(74, 166, 166) at
  // shade 6, Mantine's default primary shade for light mode). The same value is collana.com's
  // own accent token (`--e-global-color-accent: #4AA6A6`).
  colors: {
    blue: [
      '#edf6f6',
      '#d2e9e9',
      '#aed7d7',
      '#89c5c5',
      '#6bb6b6',
      '#58adad',
      '#4aa6a6',
      '#3b8585',
      '#2c6464',
      '#1e4242',
    ],
  },
});
